import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { CheckCircle2, Loader2, XCircle } from 'lucide-react';
interface ModalFooterActionsProps {
  onTest: () => void;
  testStatus: 'idle' | 'testing' | 'success' | 'error';
  testError: string;
  disableSave: boolean;
  disableTest: boolean;
  isTesting: boolean;
  isSaving: boolean;
}

export function ModalFooterActions({
  onTest,
  testStatus,
  testError,
  disableSave,
  disableTest,
  isTesting,
  isSaving,
}: ModalFooterActionsProps) {
  return (
    <div className="mt-4 grid gap-2">
      {testStatus === 'success' && (
        <div className="flex items-center gap-2 rounded-md border border-green-200 bg-green-50 px-3 py-2 text-sm text-green-700">
          <span className="flex h-5 w-5 items-center justify-center rounded-full bg-green-100 text-green-700">
            <CheckCircle2 className="h-4 w-4" />
          </span>
          <span>Test Event Sent</span>
        </div>
      )}
      {testStatus === 'error' && (
        <div className="flex items-center gap-2 rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
          <span className="flex h-5 w-5 items-center justify-center rounded-full bg-red-100 text-red-700">
            <XCircle className="h-4 w-4" />
          </span>
          <span>Test Failed - {testError}</span>
        </div>
      )}
      <Button
        type="button"
        variant="outline"
        onClick={onTest}
        className="w-full"
        disabled={isTesting || disableTest}
      >
        {isTesting ? (
          <>
            <Loader2 className="animate-spin" />
            Testing Connection...
          </>
        ) : (
          'Test Connection'
        )}
      </Button>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="w-full">
            <Button type="submit" className="w-full" disabled={disableSave}>
              {isSaving ? (
                <>
                  <Loader2 className="animate-spin" />
                  Saving Settings...
                </>
              ) : (
                'Save Settings'
              )}
            </Button>
          </span>
        </TooltipTrigger>
        {disableSave && (
          <TooltipContent side="top">
            <p>Test the connection before saving.</p>
          </TooltipContent>
        )}
      </Tooltip>
    </div>
  );
}
